import React, { useState, useEffect } from "react";
import Quill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import ExpandedSideBar from "./ExpandedSideBar";
import "../../style/DocumentViewer.css";

function DocumentViewer({ userId }) {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editorContent, setEditorContent] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_SOURCE;

  useEffect(() => {
    if (userId) {
      fetch(`${API_BASE_URL}/backend/api/Documents/fetchDocuments.php?userId=${userId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setDocuments(data.documents);
          } else {
            console.error("Error fetching documents:", data.message);
          }
        })
        .catch((err) => console.error("Error fetching documents:", err));
    }
  }, [userId]);

  useEffect(() => {
    if (selectedDocument && isEditing) {
      fetch(`${API_BASE_URL}/backend/api/Documents/viewDocuments.php?name=${encodeURIComponent(selectedDocument)}&userId=${userId}&editMode=true`)
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setEditorContent(data.htmlContent); // Load original content in Quill
          } else {
            console.error("Error loading document for editing:", data.message);
          }
        })
        .catch((err) => console.error("Error loading document for editing:", err));
    }
  }, [selectedDocument, isEditing, userId, API_BASE_URL]);

  const handleSaveEdit = () => {
    setIsEditing(false);
    const docHTML = editorContent;

    fetch(`${API_BASE_URL}/backend/api/Documents/saveEditedDocument.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        documentName: selectedDocument,
        updatedHTML: docHTML,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          fetch(`${API_BASE_URL}/backend/api/Documents/viewDocuments.php?documentId=${selectedDocument.id}`)
            .then((res) => res.json())
            .then((viewData) => {
              if (viewData.status === "success") {
                setSelectedDocument(viewData.document);
                setEditorContent(viewData.document.content); // Assuming content is in the response
                setIsEditing(false);
              } else {
                console.error("Error viewing updated document:", viewData.message);
              }
            });
        } else {
          console.error("Error saving document:", data.message);
        }
      })
      .catch((err) => console.error("Error saving document:", err));
  };

  return (
    <div className="document-page">
      <ExpandedSideBar
        documents={documents}
        setDocuments={setDocuments}
        onDocumentClick={setSelectedDocument}
        setSelectedDocument={setSelectedDocument}
        setIsEditing={setIsEditing}
      />
      <div className="document-viewer-container">
        <div className="document-viewer">
          {isEditing ? (
            <div className="edit-container">
              <div className="edit-header">
                <p style={{ color: "black" }}>Edit your document:</p>
              </div>
              <div className="quill-editor">
                <Quill
                  value={editorContent}
                  onChange={setEditorContent}
                  theme="snow"
                  style={{ color: "black", backgroundColor: "white" }}
                  modules={{
                    toolbar: [
                      [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                      ['bold', 'italic', 'underline'],
                      [{ 'align': [] }],
                      ['link'],
                      ['image'],
                    ],
                  }}
                  formats={[
                    'header', 'font', 'list', 'bold', 'italic', 'underline', 'align', 'link', 'image'
                  ]}
                />
              </div>
              <button className="save-button" onClick={handleSaveEdit}>
                Save Changes
              </button>
            </div>
          ) : selectedDocument ? (
            <iframe
              src={`${API_BASE_URL}/backend/api/Documents/viewDocuments.php?name=${encodeURIComponent(selectedDocument)}&userId=${userId}`}
              title={selectedDocument}
              frameBorder="0"
              style={{ width: "100%", height: "100%" }}
            />
          ) : (
            <p style={{ color: "black" }}>Select a document to view.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default DocumentViewer;